export default (filter, allExperiences) => {
  filter.map(filt => {
    if (filt.isArray) {
      allExperiences = allExperiences.filter((exp) => {
        let search = false
        if (exp[filt.filter])
          search = exp[filt.filter].find(auxFilt => auxFilt === filt.id)
        if (exp[filt.filter] && search)
          return exp
      })
    } else {
      if (filt.isObject) {
        allExperiences = allExperiences.filter((exp) => exp[filt.filter] && exp[filt.filter].id === filt.id)
      } else {
        allExperiences = allExperiences.filter((exp) => exp[filt.filter] && exp[filt.filter] === filt.id)
      }
    }
  })
  return allExperiences;
}